import { render, staticRenderFns } from "./GiftProductInfoList.vue?vue&type=template&id=1eb718bd&scoped=true&"
import script from "./GiftProductInfoList.vue?vue&type=script&lang=js&"
export * from "./GiftProductInfoList.vue?vue&type=script&lang=js&"
import style0 from "./GiftProductInfoList.vue?vue&type=style&index=0&id=1eb718bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb718bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eb718bd')) {
      api.createRecord('1eb718bd', component.options)
    } else {
      api.reload('1eb718bd', component.options)
    }
    module.hot.accept("./GiftProductInfoList.vue?vue&type=template&id=1eb718bd&scoped=true&", function () {
      api.rerender('1eb718bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/orderMgt/GiftProductInfoList.vue"
export default component.exports